import { SCOPE_TYPE } from '@/types';
import { hasCommunityAccess } from '@/helpers/communityAccess';

type AdminScopeFlags = {
  isGroupScope?: boolean;
  isLimitedScope?: boolean;
  scopeTypes?: SCOPE_TYPE[];
};

export const hasGroupScopeType = ({ scopeTypes, isGroupScope }: AdminScopeFlags): boolean => {
  if (scopeTypes?.length) {
    return scopeTypes.includes(SCOPE_TYPE.GROUP);
  }

  // Legacy scopes may only expose isGroupScope without scopeTypes.
  return isGroupScope === true;
};

export const hasCommunityListScopeType = ({ scopeTypes }: AdminScopeFlags): boolean => {
  if (!scopeTypes?.length) {
    return false;
  }

  return scopeTypes.includes(SCOPE_TYPE.COMMUNITY_LIST);
};

export const isRestrictedGroupAdminScope = ({ scopeTypes, isGroupScope }: AdminScopeFlags): boolean =>
  hasGroupScopeType({ scopeTypes, isGroupScope }) && !scopeTypes?.includes(SCOPE_TYPE.CHURCH);

/**
 * Limited admins are Group and/or Community List admins.
 * Prefer isLimitedScope; fall back to isGroupScope for older API payloads.
 */
export const isLimitedAdminScope = ({ isLimitedScope, isGroupScope }: AdminScopeFlags): boolean => {
  if (isLimitedScope === true) {
    return true;
  }

  if (isLimitedScope === false) {
    return false;
  }

  return isGroupScope === true;
};

export const getLimitedScopeAllowedMainNavKeys = ({ scopeTypes, isGroupScope }: AdminScopeFlags): string[] => {
  const allowedKeys: string[] = [];

  if (hasGroupScopeType({ scopeTypes, isGroupScope })) {
    allowedKeys.push('groups');
  }

  if (hasCommunityAccess({ scopeTypes })) {
    allowedKeys.push('community');
  }

  // Legacy group-only scope without scopeTypes: keep Groups as the entry point.
  if (!allowedKeys.length && isGroupScope === true) {
    allowedKeys.push('groups');
  }

  return allowedKeys;
};
